import classcat from "classcat";
import React from "react";

import { Image } from "@is/components/Image";
import { CircularThumbnailSize, MediaVariants } from "@is/constants";

import { TRANSLATE_X } from "../CircularThumbnails.constants";
import css from "./CircularThumbnail.module.css";

type Props = {
  index: number;
  thumbnailUrl: string;
  thumbnailUrls: string[];
  thumbnailSize?: CircularThumbnailSize;
};

const CircularThumbnail = ({
  thumbnailUrl,
  thumbnailUrls,
  index,
  thumbnailSize = CircularThumbnailSize.Medium,
}: Props) => {
  return (
    <div
      key={index}
      className={classcat([
        css.container,
        {
          [css.large]: thumbnailSize === CircularThumbnailSize.Large,
          [css.medium]: thumbnailSize === CircularThumbnailSize.Medium,
        },
      ])}
      style={{
        zIndex: thumbnailUrls.length - index,
        transform: `translateX(${index * -TRANSLATE_X}px)`,
      }}
    >
      <Image
        style={{ overflowClipMargin: "unset", borderRadius: "50%" }}
        mediavariant={MediaVariants.THUMBNAIL}
        placeholderMediaVariant={MediaVariants.THUMBNAIL}
        src={thumbnailUrl}
        layout="cover"
      />
    </div>
  );
};

export default CircularThumbnail;
